import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDeleteRenewal = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async ({
      sourceId,
      projectId,
      renewalId,
    }: {
      sourceId: string;
      projectId: string;
      renewalId: string;
    }) => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/renewals/${renewalId}`,
        {
          method: "DELETE",
          headers: {
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete renewal");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to delete renewal", error, data);
      },
    },
  );
};
